// import App from '../entry/App';

import { Outlet, RouteObject, Navigate, useParams, redirect } from "react-router-dom";
import NotFound from "@components/notFound";
import Layout from "../pages/layout/pc";
import Index from "../pages/main/pc/index";
import MobileIndex from "../pages/main/mobile/index";
import Chat from "../pages/chat/index";
import Preview from "../pages/preview/pc/index";
import PreConsultation from "../pages/preConsultation/index";

/**
 * Chat 组件包装器
 * 使用 sessionId 作为 key，确保 sessionId 变化时重新挂载组件
 */
const ChatWrapper = () => {
    const { sessionId } = useParams<{ sessionId?: string }>();
    // sessionId 变化时会创建新的 Chat 实例
    return <Chat key={sessionId || "new"} />;
};

const routes: RouteObject[] = [
    {
        path: "workbench",
        element: <Outlet />,
        children: [
            {
                index: true,
                element: <Navigate to="web/main" replace />,
            },
            {
                path: "web",
                element: <Layout />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="main" replace />,
                    },
                    {
                        path: "main",
                        element: <Index />,
                    },
                    {
                        path: "chat",
                        element: <ChatWrapper />,
                    },
                    {
                        path: "chat/:sessionId",
                        element: <ChatWrapper />,
                    },
                ],
            },
            {
                path: "web",
                children: [
                     {
                        path: "preview/:type/:id",
                        element: <Preview />,
                    },
                    {
                        path: "preview/:type/:id/:title",
                        element: <Preview />,
                    },
                    {
                        path: "preConsultation/:id",
                        element: <PreConsultation />,
                    },
                ],
            },
            {
                path: "mobile",
                element: <Layout />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="main" replace />,
                    },
                    {
                        path: "main",
                        element: <MobileIndex />,
                    },
                ],
            },
        ],
    },
    {
        path: "*",
        element: <NotFound />,
    },
];

export default routes;
